import styled from 'styled-components';
export const StyledPointsTableHead = styled.th`
  background-color: ${(props) => props.theme.pointsTableHead_BG} !important;
  color: ${(props) => props.theme.pointsTableHead_text} !important;
`;